import { MobModel } from "types";

import BISHOP_MOBS from "./bishop";
import SENECA_MOBS from "./seneca";

// SECTOR TIER 1 - MEDALLION RANGE: 1-20
// SECTOR TIER 2 - MEDALLION RANGE: 21-80
// SECTOR TIER 3 - MEDALLION RANGE: 81-180
// SECTOR TIER 4 - MEDALLION RANGE: 181-300
// SUB BOSS SECTOR - MEDALLIONS: 350
// FINAL BOSS SECTOR - MEDALLIONS: 400
// POST-REROLL SECTOR - MEDALLION RANGE: 500+

export const MOBS: Record<string, MobModel> = {
  ...BISHOP_MOBS,
  ...SENECA_MOBS,
};
